import { AccountResponse, ErpBankResponse } from "./account.model";
import { CardTypeResponse } from "./card.model";
import { VendorResponse } from "./vendor.model";

export class CashClosureRequest {
	data: CashClosureDataRequest = new CashClosureDataRequest();
	accounts: CashClosureAccountRequest[] = [];
	images: string[] = [];
	rollback: boolean = false;
	date: any = null;

	constructor() {
	}
}

export class CashClosureDataRequest {
	idCashier: number;
	cash: number;
	transfer: number;
	card: number;
	check: number;

	constructor() {
		this.idCashier = undefined;
		this.cash = 0;
		this.transfer = 0;
		this.card = 0;
		this.check = 0;
	}
}

export class CashClosureAccountRequest {
	clientId: number;
	image: string;
	logo: string;
	typePayment: number = 0;
	amount: number;
	reference: string;
	date: string;
	// for check
	dateCheck!: string;
	bankCheck!: number;
	numberCheck!: number;
	numberAccountCheck!: number;
	// for transfer
	accountIdTransfer!: number;
	numberTransfer!: number;
	amountAdvanceTransfer!: number;
	// for credit/debit card
	typeCard: number;
	referenceCard: string;
	authorizationCard: string;
	// IGNORE: is only for use the frontend
	client!: any;
	cash!: any;

	isComplete(): boolean {
		if (this.typePayment == 0) {
			return this.numberAccountCheck != undefined;
		}
		else if (this.typePayment == 1) {
			return this.dateCheck != undefined && this.bankCheck != undefined && this.numberCheck != undefined && this.numberAccountCheck != undefined;
		} else if (this.typePayment == 2) {
			return this.typeCard != undefined && this.referenceCard != undefined && this.authorizationCard != undefined;
		} else if (this.typePayment == 3) {
			return this.numberTransfer != undefined && this.accountIdTransfer != undefined;
		} else {
			return true;
		}
	}
}

export class LocalTransferRequest {
	from: number;
	to: number;
	issuerCash: number;
	issuerBank: number;
	receivingCash: number;
	receivingBank: number;
	docNumber: string;
	date: number;
	description: string;
	image: string;
	details: TransferDetail[];
	exchangeRate: number;
	rollback: boolean = false;
}

export class TransferDetail {
	currency: number;
	amount: number;
	document: string;
	description: string;
	externalReference: number;
	externalReferenceType: number;
}

export class BankAccountTransfer {
	amount: number;
	documentFrom: string;
	documentTypeFrom: number;
	documentTo: string;
	documentTypeTo: number;
	bankAccountIssuer: number;
	bankAccountReceiving: number;
	date: Date;
	cashAccountIssuer: number;
	cashAccountReceiving: number;
	journal: number;
	description: string;
	creationDate: Date;
	exchangeRate: number;
	employee: number;
	company: number;
}

export class HistoryCashClosureResponse {
	generalDetail: CashClosureDetail;
	daysDetail: CashClosureDetail[] = [];
	transferDetail: CashTransferDetail[] = [];
}

export class CashTransferDetail {
	sucursal: string;
	fecha: any;
	operacion: string;
	cuenta: any;
	banco: any;
	monto: number;
	descripcion: string;
	foto: any;
}

export class CashClosureDetail {
	sucursal: string;
	venta: number;
	caja: number;
	depositos: number;
	cobroTarjeta: number;
	ventaCredito: number;
	diferencia: number;
	warehousesDetail: CashClosureDetail[] = [];
}

export class HistoryClosureResponse {
	warehouse: number;
	warehouseName: string;
	sale: number;
	cash: number;
	transfer: number;
	target: number;
	credit: number;
	difference: number;
	days: CashClosureDayResponse[] = null;
	transfers: CashClosureTransferResponse[] = null;
	showDays: boolean = false;
	showTransfers: boolean = false;
	showAccountsReceivable: boolean = false;
}

export class CashClosureTransferResponse {
	id: number;
	dates: string;
	document: string;
	cashName: string;
	bankAccount: string;
	bank: string;
	amount: number;
	description: string;
	image: string;
}

export class CashClosureDayResponse {
	id: number;
	day: string;
	sale: number;
	cash: number;
	transfer: number;
	target: number;
	checkData: number;
	difference: number;
	user: string;
	photos: CashClosurePhotoResponse[] = null;
}

export class CashClosurePhotoResponse {
	id: number;
	image: string;
	requestId: number;
}

export class CashClosureAccountResponse {
	id: number;
	client: VendorResponse;
	image: string;
	type: number;
	amount: number;
	reference: string;
	date: number;
	card: AccountCardTypeResponse;
	check: AccountCheckTypeResponse;
	transfer: AccountTransferTypeResponse;
}

export class AccountCardTypeResponse {
	type: CardTypeResponse;
	reference: string;
	authorization: string;
}

export class AccountCheckTypeResponse {
	date: any;
	bank: ErpBankResponse;
	number: number;
	account: number;
}

export class AccountTransferTypeResponse {
	account: AccountResponse;
	number: number;
	advance: number;
}